import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 20V4H1v16h22zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
}), 'PanoramaSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PanoramaSharp.js
// module id = 5199
// module chunks = 2